import React from 'react';
import PropTypes from 'prop-types';
import { translate as t } from '../../lib/I18n';
import classnames from 'classnames';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import OnEnterTrigger from '../../components/general/OnEnterTrigger';
import PaymentRadio from '../../components/payment/PaymentRadio';
import config from '../../config';
import { notificationPreferences } from '../../constants/AppConstants';


 const NotifyBy = ({
     notifyByPreference,
     setNotifyByPreference,
     hasPushNotifications,
     isDDM,
     isOCDR,
}) => {
    const showAppStoreLinks = !hasPushNotifications && (notifyByPreference === notificationPreferences.APP || notifyByPreference === notificationPreferences.APP_AND_EMAIL);

    return (
        <Grid>
            <Row>
                <h2 className="auto-dr__header">{t(isDDM ? 'ddm.notify.heading' : 'auto-dr.notify.heading')}</h2>
                {isOCDR && <p>Optional</p>}
                {isDDM && <p>{t('ddm.notify.text')}</p>}

                <div className="auto-delay-repay-notification-preferences">
                    <div
                        className="auto-dr__payment-item auto-dr__payment-item--notification-preference"
                    >
                        <OnEnterTrigger
                            className={classnames('payment__selector', {
                                'payment__selector--selected': notifyByPreference === notificationPreferences.EMAIL
                            })}
                            onClick={() => setNotifyByPreference(notificationPreferences.EMAIL)}
                            srOnly={t('auto-dr.subscribe.modal-checkbox-email')}
                            disabled={ false }
                        >
                            <PaymentRadio
                                className="payment__selector__radio-icon small"
                                isSelected={notifyByPreference === notificationPreferences.EMAIL}
                            />
                            <div className="auto-dr__payment-item__label">{t('auto-dr.subscribe.modal-checkbox-email')}</div>
                        </OnEnterTrigger>
                    </div>

                    <div
                        className="auto-dr__payment-item auto-dr__payment-item--notification-preference"
                    >
                        <OnEnterTrigger
                            className={classnames('payment__selector', {
                                'payment__selector--selected': notifyByPreference === notificationPreferences.APP,
                            })}
                            onClick={() => setNotifyByPreference(notificationPreferences.APP)}
                            srOnly={t('auto-dr.subscribe.modal-checkbox-app')}
                        >
                            <PaymentRadio
                                className="payment__selector__radio-icon small"
                                isSelected={notifyByPreference === notificationPreferences.APP}
                            />
                            <div className="auto-dr__payment-item__label">{t('auto-dr.subscribe.modal-checkbox-app')}</div>
                        </OnEnterTrigger>
                    </div>

                    <div
                        className="auto-dr__payment-item auto-dr__payment-item--notification-preference"
                    >
                        <OnEnterTrigger
                            className={classnames('payment__selector', {
                                'payment__selector--selected': notifyByPreference === notificationPreferences.APP_AND_EMAIL,
                            })}
                            onClick={() => setNotifyByPreference(notificationPreferences.APP_AND_EMAIL)}
                            srOnly={t('auto-dr.subscribe.modal-checkbox-app-and-email')}
                        >
                            <PaymentRadio
                                className="payment__selector__radio-icon small"
                                isSelected={notifyByPreference === notificationPreferences.APP_AND_EMAIL}
                            />
                            <div className="auto-dr__payment-item__label">{t('auto-dr.subscribe.modal-checkbox-app-and-email')}</div>
                        </OnEnterTrigger>
                    </div>
                </div>

                <br />
                {showAppStoreLinks && <React.Fragment>
                    <p className="">{t('auto-dr.subscribe.mobile-app-description')}</p>
                    <div className="load-smartcard-modal__app-badges">
                        <a href={config.get('appStoreAppUrl')} target="_blank">
                            <img
                                src="/images/mobile-apps/app-store.png"
                                alt={t('ontrackapp.widget.appstoreButtonAltText')}
                            />
                        </a>
                        <a href={config.get('googlePlayAppUrl')} target="_blank">
                            <img
                                src="/images/mobile-apps/google-play.png"
                                alt={t('ontrackapp.widget.googlePlayButtonAltText')}
                            />
                        </a>
                    </div>
                </React.Fragment>}
            </Row>
        </Grid>
    );
};

NotifyBy.propTypes = {
    notifyByPreference: PropTypes.bool.isRequired,
    hasPushNotifications: PropTypes.bool.isRequired,
    isDDM: PropTypes.bool,
    isOCDR: PropTypes.bool,
    setNotifyByPreference: PropTypes.func.isRequired,
};

export default NotifyBy;



// WEBPACK FOOTER //
// ./src/components/account/NotifyBy.js